/**
 * All backend permission codenames (see backend feature-flag definitions).
 * Single source of truth — use these constants instead of raw strings.
 */
export const FcPermissions = {
  // Map
  mapFeature: 'fc_map_feature',
  // Company
  companyUpdate: 'fc_company_update',
  employeeInvite: 'fc_employee_invite',
  // Admin
  employeeManageAdmins: 'fc_employee_manage_admins',
  // Employee
  employeeUpdate: 'fc_employee_update',
  employeeDelete: 'fc_employee_delete',
  employeeCreate: 'fc_employee_create',
  // Employee group
  employeeGroupUpdate: 'fc_employee_group_update',
  employeeGroupDelete: 'fc_employee_group_delete',
  employeeGroupCreate: 'fc_employee_group_create',
  // Vehicle
  vehicleUpdate: 'fc_vehicle_update',
  vehicleDelete: 'fc_vehicle_delete',
  vehicleCreate: 'fc_vehicle_create',
  // Vehicle group (not used yet on the backend side)
  vehicleGroupUpdate: 'fc_vehicle_group_update',
  vehicleGroupDelete: 'fc_vehicle_group_delete',
  vehicleGroupCreate: 'fc_vehicle_group_create',
  // Live share
  liveShareCreate: 'fc_live_share_create',
  liveShareUpdate: 'fc_live_share_update',
  liveShareDelete: 'fc_live_share_delete',
  companyLiveShareAccess: 'fc_company_live_share_access',
  // DVR
  dvrViewLiveVideo: 'fc_dvr_view_live_video',
  dvrViewMedia: 'fc_dvr_view_media',
  dvrRequestPlayback: 'fc_dvr_request_playback',
  dvrSettings: 'fc_dvr_settings',
} as const;

/** Union of all valid permission codenames, e.g. 'fc_company_update'. */
export type FcPermissionCode =
  (typeof FcPermissions)[keyof typeof FcPermissions];
